import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TypographyComponent } from '../shared/ui-component/typography/typography.component';

@NgModule({
  declarations: [],
  exports: [HeaderComponent, FooterComponent],
  imports: [
    CommonModule,
    SvgIconComponent,
    RouterLink,
    RouterLinkActive,
    TypographyComponent,
    HeaderComponent,
    FooterComponent
  ]
})
export class CoreModule {}
